import React from "react";
import ReactDOM from "react-dom/client";
//import App from "./App";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";

// styles
import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";
// pages
import Index from "views/Index.js";
import LandingPage from "views/examples/LandingPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import RegisterPage from "views/examples/RegisterPage.js";
import AboutPage from "views/AboutPage.js";
import CalendarPage from "views/CalendarPage.js";
import LoginPage from "views/LoginPage.js";
import AdminLogin from "views/AdminLogin.js";
import PublicVendorProfilePage from "views/PublicVendorProfilePage";
import Announcement from "views/Announcement";


//VendorManager
import VendorManagement from "views/VendorManagement";

const isAdmin = true;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/landing-page" element={<LandingPage />} />
      <Route path="/profile-page" element={<ProfilePage />} />
      <Route path="/register-page" element={<RegisterPage />} />
      <Route path="/vendors" element={isAdmin ? <VendorManagement /> : <Navigate to="/" />}/>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/calendar" element={<CalendarPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/announcement" element={< Announcement/>} />

      <Route path="/vendor/:id" element={<PublicVendorProfilePage />} />
    </Routes>
  </BrowserRouter>
);
